// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Actions
import { emptyTrash } from '../store/trashActions';

// Selectors
import { emptyCurrentUserTrashSelector, isClearingTrashSelector, trashFetchedSelector } from '../store/trashSelector';

// Components
import StyledButton from '../../../../components/buttons/StyledButton';
import LinkButton from '../../../../components/buttons/LinkButton';
import Spinner from '../../../../components/loaders/Spinner';

// Constants
import { TRASH_TABS } from '../store/trashConstants';

// Styles
import './TrashEmptyFooter.scss';

const mapStateToProps = createStructuredSelector({
    isClearingTrash: isClearingTrashSelector,
    isEmptyTrash: emptyCurrentUserTrashSelector,
    trashFetched: trashFetchedSelector(TRASH_TABS.PERSONAL),
});

const mapDispatchToProps = (dispatch) => ({
    dispatchEmptyTrash: () => dispatch(emptyTrash()),
});

const TrashEmptyFooter = (props) => {
    const { isClearingTrash, trashFetched, isEmptyTrash, activeTab, dispatchEmptyTrash } = props;

    const [showDeleteTrashWarning, setShowDeleteTrashWarning] = React.useState(false);

    if (activeTab !== TRASH_TABS.PERSONAL) return null;

    if (isClearingTrash) {
        return (
            <div className="TrashEmptyFooter">
                <div className="clearing-trash-overlay">
                    <Spinner show />
                </div>
            </div>
        );
    }

    if (!trashFetched || isEmptyTrash) return null;

    return (
        <div className="TrashEmptyFooter">
            <StyledButton className="empty-trash-button secondary" onClick={() => setShowDeleteTrashWarning(true)}>
                Empty trash
            </StyledButton>
            {showDeleteTrashWarning && (
                <div className="empty-trash-warning">
                    <h2 className="heading">Are you sure?</h2>
                    <p className="warning-text">This will permanently delete all boards and cards in the trash.</p>

                    <StyledButton
                        className="affirmative-button danger"
                        onClick={() => {
                            dispatchEmptyTrash();
                            setShowDeleteTrashWarning(false);
                        }}
                    >
                        Continue
                    </StyledButton>
                    <LinkButton onClick={() => setShowDeleteTrashWarning(false)}>Cancel</LinkButton>
                </div>
            )}
        </div>
    );
};

TrashEmptyFooter.propTypes = {
    activeTab: PropTypes.string,
    trashFetched: PropTypes.bool,
    isEmptyTrash: PropTypes.bool,
    isClearingTrash: PropTypes.bool,
    dispatchEmptyTrash: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(TrashEmptyFooter);
